import { Link } from "react-router-dom";

const FinalCta = () => {
  return (
    <section className="lp-final-wrap">
        <div className="lp-final" data-reveal>
            <h2>Tu catálogo puede estar online hoy</h2>
            <Link to="/register" className="lp-btn lp-btn-green">Crear mi catálogo gratis</Link>
            <span>Sin tarjeta. Lo armás desde el celular o la compu.</span>
        </div>
    </section>
  )
}

export default FinalCta
